<template>
  <div class="assignment-users">
    <table>
      <thead>
        <tr class="category">
          <th rowspan="2">Users/Approvers</th>
          <th colspan="3">Time Sheets</th>
          <th colspan="3">Expenses</th>
          <th rowspan="2"></th>
        </tr>
        <tr class="perms">
          <th>Approve</th>
          <th>Submit</th>
          <th>View</th>
          <th>Approve</th>
          <th>Submit</th>
          <th>View</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, idx) in users" :key="idx">
          <td>
            <div>{{ user.display_name }}</div>
            <div v-if="user.email">
              <font-awesome-icon icon="envelope" />
              {{ user.email }}
            </div>
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_approve_time_sheets"
              @change="sendUpdateMessage(user.user_id, 'can_approve_time_sheets')"
            />
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_submit_time_sheets"
              @change="sendUpdateMessage(user.user_id, 'can_submit_time_sheets')"
            />
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_view_time_sheets"
              @change="sendUpdateMessage(user.user_id, 'can_view_time_sheets')"
            />
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_approve_expenses"
              @change="sendUpdateMessage(user.user_id, 'can_approve_expenses')"
            />
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_submit_expenses"
              @change="sendUpdateMessage(user.user_id, 'can_submit_expenses')"
            />
          </td>
          <td>
            <checkbox
              size="tiny"
              :checked="user.can_view_expenses"
              @change="sendUpdateMessage(user.user_id, 'can_view_expenses')"
            />
          </td>
          <td>
            <font-awesome-icon icon="times-circle" @click="sendRemoveMessage(user.user_id)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Checkbox from '@/app/components/Checkbox';
export default {
  components: {
    Checkbox
  },
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  methods: {
    sendUpdateMessage(userId, permission) {
      this.$emit('update', {
        userId,
        permission
      });
    },
    sendRemoveMessage(userId) {
      this.$emit('remove', {
        userId
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.assignment-users {
  table {
    border-collapse: collapse;
    thead {
      border-bottom: 2px solid $row_border;
    }
    thead tr th {
      text-transform: uppercase;
      font-size: 0.7em;
      background-color: $background-level-3;
    }

    thead tr.category,
    thead tr.perms {
      th {
        &:not(:first-of-type) {
          text-align: center;
        }
        &:not(:last-of-type) {
          border-right: 1px solid $row-border;
        }
      }
    }

    tbody tr {
      &:nth-child(even) {
        background-color: $background-level-3;
      }
    }
    tbody tr td {
      &:not(:nth-of-type(1)) {
        text-align: center;
      }
      &:last-of-type {
        svg {
          font-size: 1.5em;
        }
      }
    }

    tbody tr td:last-of-type {
      text-align: right;
      color: $row-border;
      font-size: 0.8em;
      &:hover {
        cursor: pointer;
        color: $red;
      }
    }
  }
}
</style>
